import { request, API_V1_PREFIX } from "./client";
import type { MaterialData } from "./types";

export async function getMaterials(token: string, schoolProfileId?: string): Promise<MaterialData[]> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<MaterialData[]>(`${API_V1_PREFIX}/materials${query}`, { method: "GET" }, { token });
}

export async function createMaterial(
  data: Pick<MaterialData, "title" | "content" | "type" | "school_profile_id"> & {
    unit_id?: string | null;
  },
  token: string,
): Promise<MaterialData> {
  return request<MaterialData>(
    `${API_V1_PREFIX}/materials`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function updateMaterial(
  id: string,
  data: Partial<Pick<MaterialData, "title" | "content" | "type" | "unit_id">>,
  token: string,
): Promise<MaterialData> {
  return request<MaterialData>(
    `${API_V1_PREFIX}/materials/${id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function deleteMaterial(id: string, token: string): Promise<boolean> {
  return request<boolean>(`${API_V1_PREFIX}/materials/${id}`, { method: "DELETE" }, { token });
}
